export const columnStyles = {
  avatar: {
    bgcolor: "var(--ecerto-breakdown-brown)",
    width: "3rem",
    height: "3rem",
  },
};
